<!-- ALERT & CONFIRM DIALOG -->
<p-toast></p-toast>

<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">loading...</span>
</div>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>


<div class="card">

    <!-- TOOLBAR -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" >
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                        <div class="p-col-12 p-md-4">
                            <span>{{lbl_coordination}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown id="listStore" [options]="listStore" [(ngModel)]="selectedStore"
                                placeholder="{{lbl_select}} {{lbl_coordination}}" optionLabel="descri"
                                [disabled]="true"
                                [showClear]="true" [filter]="true" (onChange)="loadWorkShopMng()"></p-dropdown>
                        </div>
                    </div>
    
    
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                        <div class="p-col-12 p-md-4">
                            <span>{{lbl_period}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown [virtualScroll]="true" [options]="listPeriods" [(ngModel)]="selectedPeriod"
                                itemSize="30" optionLabel="descrip" [showClear]="true"
                                placeholder="{{lbl_select}} {{lbl_period}}"
                                (onChange)="loadWorkShopMng()"></p-dropdown>
                        </div>
                    </div>
                </div>

                

            </p-panel>
        </div>
    </div>
    <p-tabView>

        <p-tabPanel header="{{lbl_services}} {{lbl_semester}}" leftIcon="pi pi-sort-down" [selected]="true">
            <!-- WORKSHOP LIST -->
            <p-table #dt [value]="workshopMngList" [rows]="10" [paginator]="true" [columns]="lstCols"
                [globalFilterFields]="['gui.name','gui.lastName','gui.guiType','wst.wsName','wrkStatName','chr.name','f0.strDate','f0.partN2s','f0.partN15s','f0.endDate']"
                [(selection)]="workshopMngSelected" [rowHover]="true" dataKey="particiId"
                currentPageReportTemplate="{{lbl_showing}} {first} {{lbl_of}} {last} {{lbl_records}}"
                [showCurrentPageReport]="true" responsive="true">

                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <span class="p-input-icon-left">
                            <button type="button" pButton pRipple icon="pi pi-plus" (click)="createNewWorkshopMng()"
                                class="p-mr-4 z-5" pTooltip="{{lbl_new_record}}" tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcelMng()"
                                class="p-button-success p-mr-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdfMng()"
                                class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                        </span>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{lbl_search}}..." />
                        </span>
                    </div>


                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="wst.wsName">{{lbl_type}}<p-sortIcon field="wst.wsName"></p-sortIcon></th>
                        <th pSortableColumn="gui.name">{{lbl_name}}<p-sortIcon field="gui.name"></p-sortIcon></th>

                        <th pSortableColumn="wrkStatName">{{lbl_status}}<p-sortIcon field="wrkStatName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="chr.name">{{lbl_church_name}}<p-sortIcon field="chr.name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="f0.strDate">{{lbl_starting_date}}<p-sortIcon
                                field="f0.strDate"></p-sortIcon>
                        </th>
                        <th pSortableColumn="f0.partN2s">{{lbl_participants_1st}}<p-sortIcon
                                field="f0.partN2s"></p-sortIcon></th>
                        <th pSortableColumn="f0.partN15s">{{lbl_particp15s}}<p-sortIcon
                                field="f0.partN15s"></p-sortIcon>
                        </th>

                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-data>
                    <tr>
                        <td>{{data.wst? data.wst.wsName : 'S/N'}} </td>
                        <td>{{data.guiScr.guiType}}. {{data.gui.name}} {{data.gui.lastName}}</td>
                        <td>{{data.wrkStatName ? data.wrkStatName : 'S/N'}}</td>
                        <td>{{data.chr!=null && data.chr.name ? data.chr.name : 'S/N' }}</td>
                        <td>{{data.f0.strDate? formatDate(data.f0.strDate) : 'S/N' }}</td>
                        <td>{{data.f0.partN2s ? data.f0.partN2s : '0'}} </td>
                        <td>{{data.f0.partN15s ? data.f0.partN15s : '0'}}</td>

                        <td>
                            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"
                                (click)="editWorkshopMng(data)" pTooltip="{{lbl_edit}}" *ngIf="data.f0.serTyp!='16' && data.f0.serTyp!='17' && data.f0.serTyp!='18'
                                && data.f0.status!='S' && data.f0.status!='C'"></button>
                            <button pButton pRipple icon="pi pi-check-circle"
                                *ngIf="data.f0.serTyp!='16' && data.f0.serTyp!='17' && data.f0.serTyp!='18'"
                                class="p-button-rounded p-button-success p-mr-2" (click)="showDialogStatus(data)"
                                pTooltip="{{lbl_status}}"></button>
                            <button pButton *ngIf="data.f0!=null && data.f0.status=='N'" pRipple icon="pi pi-send"
                                class="p-button-rounded p-button-info" (click)="openWorkShopApprove(data)"
                                pTooltip="{{lbl_approve}}"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{lbl_total}} {{workshopMngList ? workshopMngList.length : 0 }} {{lbl_services}}
                        {{lbl_ongoing}}
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel header="{{lbl_coordination_guide_list}}" leftIcon="pi pi-list">
            <!-- PARTICIPANT LIST -->
            <p-table #dt [value]="workshopLgcList" [rows]="10" [paginator]="true" [columns]="lstCols"
                [globalFilterFields]="['gui.guideId','guiScr.guiType','gui.name','wst.wsName','f0.status']"
                [(selection)]="workshopLgcSelected" [rowHover]="true" dataKey="particiId"
                currentPageReportTemplate="{{lbl_showing}} {first} {{lbl_of}} {last} {{lbl_records}}"
                [showCurrentPageReport]="true" responsive="true">

                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between">
                        <span class="p-input-icon-left">
                            <button type="button" pButton pRipple icon="pi pi-plus" (click)="createNewWorkshopMng()"
                                class="p-mr-4 z-5" pTooltip="{{lbl_new_record}}" tooltipPosition="bottom"></button>
                            <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcelLgc()"
                                class="p-button-success p-mr-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdfLgc()"
                                class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                        </span>

                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{lbl_search}}..." />
                        </span>
                    </div>
                </ng-template>

                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="gui.guideId">{{lbl_guideId}}<p-sortIcon field="gui.guideId"></p-sortIcon>
                        </th>
                        <th pSortableColumn="guiScr.guiType">{{lbl_type}}<p-sortIcon
                                field="guiScr.guiType"></p-sortIcon></th>
                        <th pSortableColumn="gui.name">{{lbl_name}}<p-sortIcon field="gui.name"></p-sortIcon></th>
                        <th pSortableColumn="wst.wsName">{{lbl_services}}<p-sortIcon field="wst.wsName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="f0.status">{{lbl_status}}<p-sortIcon field="f0.status"></p-sortIcon></th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-data>
                    <tr>
                        <td>{{data.gui.guideId ? data.gui.guideId : 'S/N'}} </td>
                        <td>{{data.guiScr.guiType ? data.guiScr.guiType : 'S/N'}} </td>
                        <td>{{data.gui.name}} {{data.gui.lastName}}</td>
                        <td>{{data.wst ? data.wst.wsName : 'Sin Servicio' }}</td>
                        <td>{{data.wrkStatName ? data.wrkStatName : 'S/N' }}</td>

                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{lbl_total}} {{workshopLgcList ? workshopLgcList.length : 0 }}
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>


    </p-tabView>

</div>


<p-dialog header="{{lbl_change_Status_Guide_or_Comment}}" [(visible)]="displayModalStatus" styleClass="p-fluid"
    [modal]="true" [style]="{width: '50vw'}" [maximizable]="true" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false">

    <div class="card">
        <!-- MAIN CONTENT -->
        <div class="p-grid">
            <!-- INFO -->
            <div class="p-col-12">
                <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1">
                    <span>{{lbl_coordination}}</span>
                    <span class="p-text-bold">{{workshopMngSelected != null ? workshopMngSelected.addr.addrId +" -
                        "+workshopMngSelected.addr.city+","+workshopMngSelected.addr.country
                        :""}}</span>
                </div>
                <div class="subTitle  p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_guideId}}</span>
                    <span class="p-text-bold">{{workshopMngSelected != null ? workshopMngSelected.gui.guideId +" - "+
                        workshopMngSelected.gui.name +" "+workshopMngSelected.gui.lastName : ""}} </span>
                </div>
                <div class="subTitle p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_status}} - </span>
                    <span class="p-text-bold">{{workshopMngSelected!=null ?workshopMngSelected.wrkStatName : ""}}
                        -
                        {{workshopMngSelected != null ? workshopMngSelected.f0.toTime : "POR DEFINIR"}}</span>
                </div>
            </div>
        </div>
        <!-- INPUTS -->
        <div class="p-grid">
            <!-- 1ST SECTION INFO -->
            <div class="p-col-12">

                <div class="p-fluid">
                    <!-- Estatus --> <!--TODO: FALTA ETIQUETA PARA CAMBIO DE ESTATUS-->
                    <div class="p-col-12">
                        <label for="statusModal">{{lbl_leaving_reason}} <span *ngIf="!statusSelected"
                                style="color:red">(*)</span></label>
                        <p-dropdown id="statusModal" [options]="statusList" [(ngModel)]="statusSelected"
                            placeholder="{{lbl_select}} {{lbl_leaving_reason}}" optionLabel="value"
                            [showClear]="true"></p-dropdown>
                    </div>

                    <!-- Name -->
                    <div class="p-col-12">
                        <label for="dateModal">{{lbl_date}} <span *ngIf="!dateSelected" style="color:red">
                                (*)</span></label>
                        <p-inputMask id="dateModal" slotChar="DD/MM/YYYY"
                            pattern="^(0[1-9]|1[0-9]|2[0-9]|3[0-1])/(0[1-9]|1[0-2])/(\d{4})$" mask="99/99/9999"
                            [(ngModel)]="dateSelected" placeholder="DD/MM/YYYY"></p-inputMask>

                    </div>

                    <!-- Comments -->
                    <div class="p-col-12">
                        <label for="commentsModal">{{lbl_comments}} <span *ngIf="!commentsSelected" style="color:red">
                                (*)</span></label>
                        <textarea id="commentsModal" [(ngModel)]="commentsSelected" rows="5" cols="30" pInputTextarea
                            autoResize="autoResize" maxlength="300" #myInput></textarea>
                        <label class="nopadding clrlbl">{{myInput.value.length}} / 300 </label>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">

        <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
            (click)="displayModalStatus=false"></button>

        <button pButton pRipple type="button" icon="pi pi-check" label="{{lbl_save}}"
            class="p-button-raised p-button-success" (click)="updateStatusWorkshopMng()"></button>
    </ng-template>
</p-dialog>